export default __webpack_public_path__ + "static/media/client-pointer.a2c8f8c7.png";